import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';

declare var require: any;
var CryptoJS = require('crypto-js');

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  uid;
  token;
  changePasswordFormDetails: any = {
    values: {
      password: '',
      confirm_password: '',
    },
    errors: {
      password: false,
      confirm_password: false,
    },
  };

  password_active: boolean = true;
  confirm_password_active: boolean = true;

  constructor(
    private router: Router,
    public commonService: CommonService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    activeRoute.queryParams.subscribe((params) => {
      this.uid = params.uid;
      this.token = params.token;
    });
  }

  ngOnInit(): void {
    // this.authService.logout();
  }

  validateInputFields(data, key, type) {
    if (data.values[key] !== '') {
      data.errors[key] = false;
      if (type == 'email') {
        if (
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data.values[key])
        ) {
          data.errors[key] = false;
        } else {
          data.errors[key] = true;
        }
      } else if (type == 'password') {
        if (
          this.valid_password_length == true &&
          this.valid_password_uppercase == true &&
          this.valid_password_lowercase == true &&
          this.valid_password_special == true &&
          this.valid_password_number == true
        ) {
          data.errors[key] = false;
        } else {
          data.errors[key] = true;
        }
      } else if (type == 'confirm_password') {
        if (data.values['password'] == data.values['confirm_password']) {
          data.errors[key] = false;
        } else {
          data.errors[key] = true;
        }
      }
    } else {
      data.errors[key] = true;
    }
  }

  validateForm(data) {
    let update = false;
    for (const value in data.values) {
      if (value === 'email') {
        this.validateInputFields(data, value, 'email');
      } else if (value === 'password') {
        this.validateInputFields(data, value, 'password');
      } else if (value === 'confirm_password') {
        this.validateInputFields(data, value, 'confirm_password');
      } else {
        this.validateInputFields(data, value, 'text');
      }
      update = data.values[value] !== '' ? true : false;
    }
    return update === true ? true : false;
  }

  checkFormValidation(data) {
    let update = true;
    for (const key in data) {
      if (data[key] !== '') {
        update = false;
        if (key === 'email') {
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data[key])) {
            update = false;
          } else {
            update = true;
          }
        } else if (key === 'confirm_password') {
          if (data['password'] === data['confirm_password']) {
            update = false;
          } else {
            update = true;
          }
        }
      } else {
        update = true;
      }
    }
    return update === true ? true : false;
  }

  button_loading_state: boolean = false;
  changePass() {
    let postObj = {
      new_password: this.encryptPassword(
        JSON.parse(
          JSON.stringify(this.changePasswordFormDetails.values.password),
        ),
      ),
      token: this.token,
      uid: this.uid,
    };
    this.button_loading_state = true;
    if (
      this.validateForm(this.changePasswordFormDetails) &&
      !this.checkFormValidation(this.changePasswordFormDetails.values)
    ) {
      this.commonService.postData('/update_forgotpassword/', postObj).subscribe(
        (res: any) => {
          this.router.navigate(['/login']);
          this.commonService.showToast(
            'success',
            'Reset Password Successfully',
          );
          this.button_loading_state = false;
        },
        (err: any) => {
          if (err.error.success == 0) {
            if (err.error.status == 'fail') {
              this.openPasswordExistModal();
            } else {
              this.commonService.showToast(
                'error',
                'Your Verification link has been expired. Please generate a new link and try again',
              );
            }
          }
          this.button_loading_state = false;
        },
      );
    } else {
      this.button_loading_state = false;
    }
  }

  navigate(url) {
    this.router.navigate([url]);
  }

  encryptPassword(password: string): string {
    const ciphertext = CryptoJS.AES.encrypt(
      password,
      'WealthGrowth-Secret-Key',
    ).toString();
    return ciphertext;
  }

  valid_password_length: boolean = false;
  checkPasswordLength(password) {
    if (password.length > 7) {
      this.valid_password_length = true;
      return true;
    } else {
      this.valid_password_length = false;
      return false;
    }
  }

  valid_password_uppercase: boolean = false;
  checkPasswordUppercase(password) {
    this.valid_password_uppercase = /[A-Z]/.test(password);
    return /[A-Z]/.test(password);
  }

  valid_password_lowercase: boolean = false;
  checkPasswordLowercase(password) {
    this.valid_password_lowercase = /[a-z]/.test(password);
    return /[a-z]/.test(password);
  }

  valid_password_special: boolean = false;
  checkPasswordSpecial(password) {
    this.valid_password_special =
      /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
  }

  valid_password_number: boolean = false;
  checkPasswordNumber(password) {
    this.valid_password_number = /\d/.test(password);
    return /\d/.test(password);
  }

  passdwordValidation(password) {
    this.checkPasswordLength(password);
    this.checkPasswordUppercase(password);
    this.checkPasswordLowercase(password);
    this.checkPasswordSpecial(password);
    this.checkPasswordNumber(password);
  }

  @ViewChild('passwordExistModal') passwordExistModal: TemplateRef<any>;
  private passwordExistModalRef: MatDialogRef<TemplateRef<any>>;
  openPasswordExistModal() {
    this.passwordExistModalRef = this.dialog.open(this.passwordExistModal, {
      disableClose: true,
    });
    this.passwordExistModalRef.afterClosed().subscribe((result) => {
      this.closePasswordExistModal();
    });
  }

  closePasswordExistModal() {
    this.passwordExistModalRef.close();
  }
}
